module.exports = __webpack_public_path__ + "img/sundry_food.b0811fea.jpg";